import React from "react";

import { useGetProfileId } from "_common/hooks/auth";

import Presentation from "./presentation";

const component = props => {

	const myProfileId  = useGetProfileId ();
	const isOwnProfile = myProfileId === props.userId;

	return (
		<Presentation
			handleGAEvent = { () => {} }
			inView        = { props.inView }
			isOwnProfile  = { isOwnProfile }
			reel          = { props.reel }
		/>
	);
};

export default component;